import React, {Component, createRef} from "react";
import Icon from "../Icon";

import classes from "./styles.module.css";

class Help extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpened: false,
        }

        this.width = props.width;
        this.marginTop = props.marginTop;
        this.marginLeft = props.marginLeft;

        this.toggleState = this.toggleState.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.help = createRef();
        this.popup = createRef();

    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, false);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        document.addEventListener('click', this.handleClickOutside, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, false);
    }

    handleClickOutside = (e) => {

        if (!this.help.current || !this.help.current.contains(e.target)) {
            this.setState({
                isOpened: false
            });
        }
    }

    toggleState() {
        this.setState({isOpened: !this.state.isOpened});
    }

    render() {
        const helpClassName = [classes.Help, this.props.placement === "bottom" ? classes.HelpBottom : null]
            .filter(Boolean)
            .join(" ");
        const helpStyle = {
            top: this.marginTop ? this.marginTop + "px" : 0,
            marginLeft: this.marginLeft ? this.marginLeft + "px" : undefined,
        };

        return (
            <div ref={this.help} style={helpStyle} className={helpClassName}>


                <div onMouseEnter={this.toggleState} onMouseLeave={this.toggleState} className={classes.Icon}>
                    <Icon icon="question" size={'14px'}/>
                </div>

                {this.state.isOpened && (
                    <div style={{width: this.width + 'px'}} ref={this.popup} className={classes.Popup}>
                        <div className={classes.Arrow}/>
                        {this.props.children}
                    </div>
                )
                }
            </div>
        )
    }
}

export default Help;



// WEBPACK FOOTER //
// ./src/Components/Utils/Help/index.js